import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { AppHeader } from "@/components/AppHeader";
import { CoachConversation } from "@/components/CoachConversation";
import { SayingsEditor } from "@/components/SayingsEditor";
import { WorkbookUpload } from "@/components/WorkbookUpload";
import { SalesOverview } from "@/components/SalesOverview";
import { Inbox } from "lucide-react";

export default function CoachInbox() {
  const [params, setParams] = useSearchParams();
  const [sessions, setSessions] = useState(null);
  const selected = params.get("session");

  useEffect(() => {
    const load = () => api.get("/admin/sessions").then((r) => setSessions(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 10000);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="min-h-screen bg-[#FDFBF7]">
      <AppHeader />
      <main className="max-w-7xl mx-auto px-4 md:px-10 py-8">
        <div className="eyebrow text-[#5C6A61]">coach inbox</div>
        <div className="flex flex-wrap items-end justify-between gap-4 mt-1 mb-8">
          <h1 className="font-serif-display text-4xl md:text-5xl text-[#1C221D]">Your clients</h1>
          <div className="flex flex-wrap gap-3">
            <SalesOverview />
            <WorkbookUpload />
            <SayingsEditor />
          </div>
        </div>
        <div className="grid lg:grid-cols-5 gap-6">
          <aside className="lg:col-span-2 bg-white rounded-3xl border border-[#2A3B32]/10 overflow-hidden" data-testid="coach-session-list">
            {sessions === null ? (
              <div className="p-10 text-center text-[#5C6A61]" data-testid="coach-inbox-loading">Loading conversations…</div>
            ) : sessions.length === 0 ? (
              <div className="p-10 text-center text-[#5C6A61]">
                <Inbox className="mx-auto mb-3" size={22} />
                No client conversations yet.
              </div>
            ) : (
              <ul className="divide-y divide-[#2A3B32]/8 max-h-[75vh] overflow-y-auto chat-scroll">
                {sessions.map((s) => (
                  <li key={s.id}>
                    <button
                      onClick={() => setParams({ session: s.id })}
                      data-testid={`coach-session-${s.id}`}
                      className={`w-full text-left px-5 py-4 transition-colors duration-200 ${selected === s.id ? "bg-[#F2EBE5]" : "hover:bg-[#FDFBF7]"}`}
                    >
                      <div className="flex items-center justify-between gap-2">
                        <span className="font-medium text-[#1C221D] truncate">{s.client_name}</span>
                        <span className="eyebrow text-[#5C6A61] shrink-0">{s.category}</span>
                      </div>
                      <div className="text-sm text-[#1C221D] truncate mt-0.5">{s.title}</div>
                      <div className="text-xs text-[#5C6A61] truncate mt-0.5">{s.last_preview || "No messages yet"}</div>
                      {s.ai_paused && <div className="text-xs text-[#E07A5F] mt-1">You're replying personally</div>}
                    </button>
                  </li>
                ))}
              </ul>
            )}
          </aside>
          <section className="lg:col-span-3">
            {selected ? (
              <CoachConversation sessionId={selected} />
            ) : (
              <div className="bg-white rounded-3xl border border-[#2A3B32]/10 p-12 text-center text-[#5C6A61]">
                Pick a conversation to read it and reply.
              </div>
            )}
          </section>
        </div>
      </main>
    </div>
  );
}
